<template>
  <div id="step5-content" class="container_layout" style="max-width:none;">
    <transition
      mode="out-in"
      enter-active-class="animated fadeIn faster"
      leave-active-class="animated fadeOut faster ">
      <!-- loading動畫 -->
      <span v-if="loading" style="text-align:center;margin-top:100px;height:100%;font-size:24px;">
        <div class="loader" style="margin-top:100px;">
          <div class="loader_text" style="margin-top:150px;margin-left:20px;">規劃中...</div>
          <div class="inner one"></div>
          <div class="inner two"></div>
          <div class="inner three"></div>
        </div>
      </span>
      <WarningText v-else-if="error">{{error}}</WarningText>
      <div v-else class="lazyload_content">
        <div id='paging-for-pdf-1'>
          <!-- 廣告活動目的 > 規劃摘要 -->
          <div v-if="isPurposePath" id='step5-section1'>
            <div class='max-800'>
              <el-row :gutter="24">
                <el-col :span="24" :offset="0" class="guide_context">
                  <div class="guide_meta">規畫摘要</div>
                  <p>
                    根據本次廣告目的 - <span class='bold-text'>{{purposeType.name}}</span><br>
                    QuickPlan 建議採用以下<span class='bold-text'>預算配比(%)</span>以發揮最佳綜效：
                  </p>
                  <PurposeSummary></PurposeSummary>
                </el-col>
              </el-row>
                <div style="text-align:center;">＊以上建議透過機器學習過往相似目的之廣告活動，AI推薦最佳觸及效益的預算配比</div>
              <el-row>

              </el-row>
            </div>
          </div>
          <!-- 廣告活動目的 > 受眾量體與建議預算 -->
          <div v-if="isPurposePath" id='step5-uu-budget'>
            <div class='max-800'>
              <el-row :gutter="24">
                <el-col :span="24" :offset="0" class="guide_context">
                  <div class="guide_meta">受眾量體與建議預算</div>
                  <span class="guide_option">
                    廣告走期
                    <b>{{duration}}</b> 天
                    於OneAD網海中預估可觸及到的
                    <b>{{audienceDescriptionForContent}}</b>
                    不重複使用者 (UU)
                  </span>
                </el-col>
              </el-row>
              <el-row :gutter="24" v-if="planningResults" id='product-lines'>
                <el-col :span="9">
                  <div id='superimpact-info' class='product-line' v-if='showSuperImpact'>
                    <div class='product-line-name'>SuperImpact</div>
                    <div class='product-line-result'>
                      Total {{toLocaleString(planningResults['SuperImpact']['cross_device']['total_uu'])}} UU，預算建議
                      ${{toLocaleString(planningResults['SuperImpact']['cross_device']['budget'])}}
                      以觸及 {{toPercentage(planningResults['SuperImpact']['cross_device']['reach'])}} 之 開放網海 目標受眾<br/>
                      分裝置預算配比：<br/>
                      - Mobile ${{toLocaleString(planningResults['SuperImpact']['mobile']['budget'])}}<br/>
                      - Desktop ${{toLocaleString(planningResults['SuperImpact']['desktop']['budget'])}}
                    </div>
                  </div>
                  <div id='superview-info' class='product-line' v-if='showSuperView'>
                    <div class='product-line-name'>SuperView</div>
                    <div class='product-line-result'>
                      Total {{toLocaleString(planningResults['SuperView']['cross_device']['total_uu'])}} UU，預算建議
                      ${{toLocaleString(planningResults['SuperView']['cross_device']['budget'])}}
                      可觸及 {{toPercentage(planningResults['SuperView']['cross_device']['reach'])}} 之 追劇娛樂 Instream 目標受眾
                    </div>
                  </div>
                  <div id='linetoday-info' class='product-line' v-if='showLINE'>
                    <div class='product-line-name'>LINE Today</div>
                    <div class='product-line-result'>
                      Total {{toLocaleString(planningResults['LINE TODAY']['mobile']['total_uu'])}} UU，預算建議
                      ${{
                        toLocaleString(planningResults['LINE TODAY']['mobile']['budget'])}}
                      可觸及 {{toPercentage(planningResults['LINE TODAY']['mobile']['reach'])}} 之 LINE Today 目標受眾
                    </div>
                  </div>
                </el-col>
                <el-col :span="15" id='product-line-chart-wrapper'>
                  <highcharts :options="chartOptions"></highcharts>
                </el-col>
              </el-row>

            </div>
          </div>
        </div>

        <!-- 輪廓剖析 -->
        <div id="step5-profile-analysis">
          <div id='paging-for-pdf-2'>
            <div class="max-800 step5charts">
              <el-row class="guide_result_TA">
                <el-col :span="24" :offset="0" class="guide_meta">
                  <span class="guide_option">輪廓剖析 : {{audienceDescriptionForTitle}}</span>
                </el-col>

                <!-- only for Audience Path-->
                <div id='analysis-description' v-if="isAudiencePath && (calculationResult !== null)">
                  預估 30 天 於 OneAD 網海中可觸及到 {{audienceDescriptionForContent}} 不重複使用者（UU）為
                  <span class="guide_result">Cross-device {{toLocaleString(calculationResult.cross_device.total_uu)}} UU</span>；分裝置觸及
                  <span class="guide_result">Mobile {{toLocaleString(calculationResult.mobile.total_uu)}} UU</span> &
                  <span class="guide_result">Desktop {{toLocaleString(calculationResult.desktop.total_uu)}} UU</span>
                </div>
                <div> </div>
                <!-- only for 特定族群 -->
                <!-- e.g. <span>※ 新婚夫妻：從事專業、管理類型的工作。關注國際時事、商業、科技趨勢，隨時保持在up-to-date的狀態。經濟獨立手頭寬裕，維持舒適的生活品質。</span> -->
                <el-col v-if="isChooseGroupBySpecificGroup && target.description" :span="24" :offset="0" style="display: flex; margin-bottom:20px">
                  <div>
                    ※ {{this.targetOptionName}}：{{ target.description }}
                  </div>
                </el-col>

                <!------------------------>
                <!-- 性別年齡分布圖表與文字 -->
                <!------------------------>
                <el-col v-if="isNotChooseGroupByGenderAge" :span="24" :offset="0" class="audiance_box">
                  <div class="audiance_text">
                    <div class="audiance_text_title">性別年齡分布</div>
                    <span class="guide_result">{{ demographicMostHpcPercentage }}</span>
                    擁有較多
                    <span v-if="isChooseGroupByHotIndustry">
                      <HpcSuggestion shownElementOtherWord="含量"></HpcSuggestion>
                    </span>
                    <span v-else>受眾含量</span>。
                    <span v-if="isChooseGroupByHotIndustry">，再者
                      <span class="guide_result">{{ demographicMoreRelativeOutputRate }} </span>
                      表現出較高的HPC相對產出率，可同時搭配運用，加速網羅大量HPC。
                    </span>
                  </div>
                  <div class="audiance_box_gutter"></div>
                  <div class="audiance_pic" v-if="chartGenderAgeSeries">
                    <GenderAgeChart :series="chartGenderAgeSeries"></GenderAgeChart>
                  </div>
                </el-col>

                <!------------------------>
                <!-- 興趣分布圖與文字 -->
                <!------------------------>
                <el-col v-if="chartInterestSeries" :span="24" :offset="0" class="audiance_box">
                  <div class="audiance_text">
                    <div class="audiance_text_title">興趣分布</div>
                    <span class="guide_result">{{ interest_top }}</span>等興趣屬性擁有較多的
                    <span v-if="isChooseGroupByHotIndustry">
                      <HpcSuggestion shownElementOtherWord="含量"></HpcSuggestion>
                    </span>
                    <span v-else>受眾含量</span>。
                    <span v-if="isChooseGroupByHotIndustry">
                      而
                      <span class="guide_result"> {{interestHpcIndexTopTwoWording}} </span>
                      等興趣屬性的 HPC 相對產出率較高，可加強鎖定。
                    </span>
                  </div>
                  <div class="audiance_box_gutter"></div>
                  <div class="audiance_pic" v-if="chartInterestSeries">
                    <InterestChart :series="chartInterestSeries"></InterestChart>
                  </div>
                </el-col>

                <!------------------------>
                <!-- 特定議題分佈 ( 依HPC含量排序 ) -->
                <!------------------------>
                <el-col v-if="chartKeywordHpcPercentageSeries" :span="24" :offset="0" class="audiance_box">
                  <div class="audiance_text">
                    <div class="audiance_text_title">
                      特定議題分布
                      <span v-if="isChooseGroupByHotIndustry">( 依HPC含量排序 )</span>
                    </div>
                    <span class="guide_result">{{ keywordHpcPercentageTop3Name }}</span>等特定議題擁有較多的
                    <span v-if="isChooseGroupByHotIndustry">
                      <HpcSuggestion shownElementOtherWord="含量"></HpcSuggestion>
                    </span>
                    <span v-else>受眾含量</span>。
                  </div>
                  <div class="audiance_box_gutter"></div>
                  <div class="audiance_pic">
                    <KeyWordHPC :series="chartKeywordHpcPercentageSeries"></KeyWordHPC>
                  </div>
                </el-col>

                <!------------------------>
                <!-- 特定議題分佈 ( 依HPC Index 排序 ) -->
                <!-- 只有「熱門產業受眾」有 HPC Index 圖表 -->
                <!------------------------>
                <el-col v-if="isChooseGroupByHotIndustry && chartKeywordHpcIndexSeries" :span="24" :offset="0" class="audiance_box">
                  <div class="audiance_text">
                    <div class="audiance_text_title">特定議題分布 ( 依HPC Index 排序 )</div>
                    <span class="guide_result">{{ keywordHpcIndexTop3Name }}</span>等特定議題HPC表現出較高的互動意願，可視為能有效率地累積高潛力消費者的客群。
                  </div>
                  <div class="audiance_box_gutter"></div>
                  <div class="audiance_pic">
                    <KeyWordHPCIndex :series="chartKeywordHpcIndexSeries" :showBaseLine="false"></KeyWordHPCIndex>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div id='paging-for-pdf-3'>
            <div class="max-800 step5charts">
              <el-row class="guide_result_TA">
                <!------------------------>
                <!-- 網站類型分析 -->
                <!------------------------>
                <el-col v-if="chartWebsiteSeries" :span="24" :offset="0" class="audiance_box">
                  <div class="audiance_text">
                    <div class="audiance_text_title">網站類型分布</div>
                    活躍於 <span class="guide_result">{{ media_category }}</span> 類型之網站，又以
                    <span class="guide_result">{{ media_rank }}</span>
                    為前五名經常造訪的網站。
                  </div>
                  <div class="audiance_box_gutter"></div>
                  <div class="audiance_pic">
                    <WebSiteChart :series="chartWebsiteSeries"></WebSiteChart>
                  </div>
                </el-col>

                <!------------------------>
                <!-- 裝置分析 -->
                <!------------------------>
                <el-col v-if="chartDeviceSeries" :span="24" :offset="0" class="audiance_box">
                  <div class="audiance_text">
                    <div class="audiance_text_title">裝置分布</div>
                    桌機裝置佔比為 {{target.device.desktop}}%，行動裝置佔比為 {{target.device.mobile}}%，受眾於
                    <span class="guide_result">{{moreActivityDevice}}</span> 裝置上更為活躍。
                  </div>
                  <div class="audiance_box_gutter"></div>
                  <div class="audiance_pic">
                    <DeviceChart :series="chartDeviceSeries"></DeviceChart>
                  </div>
                </el-col>

                <!------------------------>
                <!-- HPC定義說明文字 -->
                <!------------------------>
                <el-col v-if="isChooseGroupByHotIndustry" :span="24" :offset="0" class="audiance_box">
                  <div class="hpc_infomation">
                    <i class="fas fa-info-circle"></i>
                    <span>
                      當消費者在非影音內容網站 (Outstream) 觀看相關產業的影音廣告，觀看長度在桌機達 50%
                      或行動裝置達 25% 以上或採取點擊等行動，即反映了對該產業有關注/興趣，OneAD 將其定義為 HPC
                    </span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { baseInfoFormatConvertor } from '@/utils/baseInfoFormat'
import { getDatesSeries } from '@/utils/date'
import { toLocaleString, toPercentage } from '@/utils/dataConvert'
import conditionApi from '@/api/conditions'
import InterestChart from '@/views/Guide/charts/InterestChart'
import GenderAgeChart from '@/views/Guide/charts/GenderAgeChart'
import WebSiteChart from '@/views/Guide/charts/WebSiteChart'
import DeviceChart from '@/views/Guide/charts/DeviceChart'
import OutComeUuChart from '@/views/Guide/charts/OutComeUuChart'
import KeyWordHPC from '@/views/Guide/charts/KeyWordHPC'
import KeyWordHPCIndex from '@/views/Guide/charts/KeyWordHPCIndex'
import WarningText from '../components/WarningText'
import { PATH_TYPE } from '../Const'
import HpcSuggestion from '@/views/HpcSuggestion'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import PurposeSummary from '@/views/Guide/steps/purpose_summary.vue'
import { PRODUCT_LINE } from '@/constant'
import dataReducer from '@/utils/data/dataReducerForSpeed'
exportingInit(Highcharts)

export default {
  name: 'step5',
  components: {
    HpcSuggestion,
    WarningText,
    InterestChart,
    GenderAgeChart,
    WebSiteChart,
    DeviceChart,
    OutComeUuChart,
    KeyWordHPC,
    KeyWordHPCIndex,
    PurposeSummary
  },
  props: ['path', 'loading', 'selectedDataFromGuide', 'calculationResultFromGuide'],
  data () {
    return {
      error: null,
      calculationResult: null,
      toLocaleString,
      toPercentage,
      defaultClientName: 'OneAD', // 如果沒有 clientName 就給預設的 clientName，後端做計算需要
      planningResults: null,
      chartOptions: {},
      showSuperImpact: false,
      showSuperView: false,
      showLINE: false,
      PRODUCT_LINE_IDS: {
        SuperImpact: 9,
        SuperViewDrama: 12,
        LineToday: 4
      }
    }
  },
  computed: {
    pathSpecificState () {
      return this.$store.state.guide[this.path]
    },
    purposeType () {
      return this.pathSpecificState.purposeType
    },
    schedule () {
      return this.pathSpecificState.schedule
    },
    duration () {
      return this.pathSpecificState.duration
    },
    reachRate () {
      return this.pathSpecificState.reachRate
    },
    targetTypeId () {
      return this.pathSpecificState.targetType.id
    },
    targetTypeName () {
      return this.pathSpecificState.targetType.name
    },
    targetOptionName () {
      return this.pathSpecificState.targetOption.name
    },
    isNotChooseGroupByGenderAge () {
      return this.pathSpecificState.targetType.id !== 1
    },
    isChooseGroupByGenderAge () {
      return this.pathSpecificState.targetType.id === 1
    },
    isChooseGroupByHotIndustry () {
      return this.pathSpecificState.targetType.id === 2
    },
    isChooseGroupBySpecificGroup () {
      return this.pathSpecificState.targetType.id === 3
    },
    isPurpose4 () {
      return this.pathSpecificState.purposeType.id === 4
    },
    productLineChartHeight () {
      let numProductLineShown = 0
      let retval = null
      if (this.showSuperImpact) numProductLineShown++
      if (this.showSuperView) numProductLineShown++
      if (this.showLINE) numProductLineShown++

      switch (numProductLineShown) {
        case 1:
          retval = '160px'
          break
        case 2:
          retval = '310px'
          break
        case 3:
          retval = '450px'
          break
      }
      return retval
    },
    ...mapState({
      // purposeType: state => state.guide.purpose.purposeType,
      // schedule: state => state.guide.purpose.schedule,
      // duration: state => state.guide.purpose.duration,
      // reachRate: state => state.guide.purpose.reachRate,
      rootOptionData: state => state.guide.root.optionData,
      target: state => state.guide.target
      // step 2 選擇的受眾分類 id 1~3
      // targetTypeId: state => state.guide.purpose.targetType.id,
      // step 2 選擇的受眾分類名 e.g. '年齡性別', '產業熱門受眾', '特定族群'
      // targetTypeName: state => state.guide.purpose.targetType.name,
      // 族群、年齡、產業名 e.g. 新婚夫妻、45-54M、豪華汽車...
      // targetOptionName: state => state.guide.purpose.targetOption.name,
      // 受眾類型選擇年齡性別
      // isNotChooseGroupByGenderAge: state => state.guide.purpose.targetType.id !== 1,
      // isChooseGroupByHotIndustry: state => state.guide.purpose.targetType.id === 2,
      // isChooseGroupBySpecificGroup: state => state.guide.purpose.targetType.id === 3,
      // isPurpose4: state => state.guide.purpose.purposeType.id === 4
    }),
    ...mapState('speedCalculation2', ['options']),
    ...mapState('root', ['baseInfo']),
    ...mapGetters('root', ['userId', 'userName', 'userClientName', 'userIsReseller']),
    isPrimeConditionForSpeed () {
      // speed 限定:
      // 受眾鎖定類別(e.g. 性別年齡) 標注不需要理會「廣告活動目的」裡的 is_prime
      // 一律都是回 false
      // 且興趣需要全選，不理會推薦興趣 見 getInterestIds ()
      if (this.ignoreIsPrimeOption()) return 0
      return Number(this.planData ? this.planData.is_prime : false)
    },
    isAudiencePath () { return this.path === PATH_TYPE.AUDIENCE },
    isPurposePath () { return this.path === PATH_TYPE.PURPOSE },
    specialDescriptionForPurpose4 () {
      return this.isPurpose4 ? '＊依本廣告目的，建議採用全手機格式以達最大觸及' : ''
    },
    chartOutcomeUuSeries () {
      if (!this.calculationResult) return null
      const result = [{
        'data': [ [ '受眾UU數', this.calculationResult.mobile.total_uu ] ],
        'name': '目標受眾UU數 (Mobile)',
        'turboThreshold': 0,
        'marker': {
          'enabled': false
        },
        'colorByPoint': false
      },
      {
        'data': [ [ '受眾UU數', this.calculationResult.mobile.reach_uu ] ],
        'name': '預算可觸及之目標受眾UU數 (Mobile)',
        'turboThreshold': 0,
        'colorByPoint': false,
        'negativeColor': null
      },
      {
        'data': [ [ '受眾UU數', 0 ] ],
        'name': '--',
        'turboThreshold': 0,
        'colorByPoint': false,
        'negativeColor': null
      },
      {
        'data': [['受眾UU數', this.calculationResult.desktop.total_uu]],
        'name': '目標受眾UU數 (Desktop)',
        'turboThreshold': 0,
        'colorByPoint': false
      }]

      if (this.calculationResult.desktop.reach_uu) {
        result.push({
          'data': [['受眾UU數', this.calculationResult.desktop.reach_uu]],
          'name': '預算可觸及之目標受眾UU數 (Desktop)',
          'turboThreshold': 0
        })
      }

      return result
    },
    // 根據第三步選擇描述目標受眾所產生的描述文字
    audienceDescriptionForContent () {
      switch (this.targetTypeId) {
        case 1:
          return ` ${this.changeAgeFormatFull(this.targetOptionName)}`
        case 2:
          return `${this.targetOptionName} 熱門受眾`
        case 3:
          return `${this.targetOptionName}`
      }
    },
    audienceDescriptionForTitle () {
      // 1. 年齡性別: 『輪廓剖析 : 25-34 女性 (年齡性別)』
      // 2. 產業熱門受眾: 『輪廓剖析 : 進口一班汽車 (產業熱門受眾)』
      // 3. 特定族群: 『輪廓剖析 : 科技迷 (特定族群)』
      switch (this.targetTypeId) {
        case 1:
          return `${this.changeAgeFormatFull(this.targetOptionName)} (${this.targetTypeName})`
        case 2:
        case 3:
          return `${this.targetOptionName} (${this.targetTypeName})`
        default: return ''
      }
    },

    // 興趣分佈的 HPC Index top 2
    // return an Array of String
    // ex. ['運動體育', '房屋地產']
    interestHpcIndexTop2 () {
      return this.$lodash.cloneDeep(this.target.interest_rank)
        .sort((a, b) => b.hpc_index - a.hpc_index)
        .slice(0, 2)
        .map((interest) => interest.name)
    },
    // hpc 含量 top 20, index top 10
    topKeywordIds () {
      let keywordsOptions = this.options.keywords
      return this.$lodash.cloneDeep(this.target.keyword_top_for_calculation).filter(keywordId => {
        return keywordsOptions.find(keyword => keyword.remote_id === keywordId)
      })
    },
    keywordHpcIndexTop3Name () {
      return this.target.keyword_hpc_index_top.map(item => item.name).join('、')
    },
    keywordHpcPercentageTop3Name () {
      return this.target.keyword_percentage_top.map(item => item.name).join('、')
    },
    // 興趣分布Top 2的字串
    // return a String
    // ex. '運動體育、房屋地產'
    interestHpcIndexTopTwoWording () {
      return this.interestHpcIndexTop2.join('、')
    },
    /**
     * 準備「性別年齡分佈」圖表的資料
     */
    chartGenderAgeSeries () {
      if (this.target.demographic_rank === undefined) return null
      const copyDemographicRank = this.$lodash.cloneDeep(this.target.demographic_rank)
      copyDemographicRank.sort((a, b) => {
        let ageA = a.name.split('-')[0] * 1
        let ageB = b.name.split('-')[0] * 1

        if (isNaN(ageA)) {
          ageA = 56
        }
        if (isNaN(ageB)) {
          ageB = 56
        }
        return ageA - ageB
      })

      // HPC含量的 bar chart series
      let ageHpcPercentage = copyDemographicRank.map(demographic => {
        return [this.changeAgeFormatSimple(demographic.name), parseFloat(demographic.percentage)]
      })

      // HPC含量的 bar chart series ( 屏除掉 top 3以外的數值 )
      let topThree = this.target.demographic_top.map(demographic => this.changeAgeFormatSimple(demographic.name))
      // let clonedHpcPercentage = [...ageHpcPercentage]
      // 不能用 array 展開當做複製，是 bug ?
      let ageTopThreePercentage = this.$lodash.cloneDeep(ageHpcPercentage)
      ageTopThreePercentage.forEach(item => {
        if (!topThree.includes(item[0])) item[1] = null
      })

      // HPC Index 的 line chart series
      let ageHpcIndex = copyDemographicRank.map(demographic => {
        return [this.changeAgeFormatSimple(demographic.name), parseFloat(demographic.hpc_index)]
      })

      // HPC Index 的 line series ( 屏除 top 2 以外的數值 )
      // 同上，interestHpcIndexSeriesTop2Only只是把非top2的數值設為null, 長度必須與HPC Index series一樣
      let genderHpcIndexSeriesTop2Only = this.$lodash.cloneDeep(ageHpcIndex)
      let demographicTopFormatted = this.target.demographic_index.map((demographic) => this.changeAgeFormatSimple(demographic))
      genderHpcIndexSeriesTop2Only.forEach(item => {
        if (!demographicTopFormatted.includes(item[0])) item[1] = null
      })

      const result = [
        {
          name: this.isChooseGroupByHotIndustry ? 'HPC 含量' : '受眾含量',
          type: 'column',
          yAxis: 0,
          'data': ageHpcPercentage,
          tooltip: {
            valueSuffix: ' %'
          },
          'turboThreshold': 0,
          'marker': {
            'symbol': 'circle',
            'enabled': false
          }
        },
        {
          name: 'TOP3 含量',
          type: 'column',
          yAxis: 0,
          data: ageTopThreePercentage,
          marker: {
            enabled: false
          },
          tooltip: {
            valueSuffix: ' %'
          },
          'turboThreshold': 0
        }
      ]

      if (this.isChooseGroupByHotIndustry) {
        result.push({
          name: 'HPC Index',
          type: 'line',
          yAxis: 1,
          data: ageHpcIndex,
          tooltip: {
            valueSuffix: ''
          },
          'marker': {
            'symbol': 'circle',
            'enabled': false
          },
          'turboThreshold': 0,
          'dashStyle': 'Solid'
        })

        // HPC Index series with top 2 values only
        result.push({
          yAxis: 1,
          data: genderHpcIndexSeriesTop2Only,
          name: 'Top Rate',
          turboThreshold: 0,
          type: 'scatter',
          marker: { symbol: 'circle', enabled: true },
          _colorIndex: 3,
          _symbolIndex: 3,
          enableMouseTracking: false,
          showInLegend: false
        })
      }
      return result
    },
    chartInterestSeries () {
      if (this.target.interest_rank === undefined) return null

      // HPC含量的 bar chart series
      let interestHpcPercentageSeries = this.target.interest_rank.map(mediaItem => {
        return [mediaItem.name, parseFloat(mediaItem.percentage)]
      })

      // HPC含量的 bar chart series ( 屏除掉 top 3以外的數值 )
      // Top 3 percentage 的 array 要跟 interestHpcPercentageSeries 一樣長。只是把 top 3的圖蓋在第一個series的圖上
      let topThree = this.target.interest_top.map((interest) => interest.name)
      let interestHpcPercentageSeriesTop3Only = this.$lodash.cloneDeep(interestHpcPercentageSeries)
      interestHpcPercentageSeriesTop3Only.forEach(item => {
        if (!topThree.includes(item[0])) item[1] = null
      })

      // HPC Index 的 line chart series
      let interestHpcIndexSeries = this.target.interest_rank.map(mediaItem => {
        return [mediaItem.name, parseFloat(mediaItem.hpc_index)]
      })

      // HPC Index 的 line series ( 屏除 top 2 以外的數值 )
      // 同上，interestHpcIndexSeriesTop2Only只是把非top2的數值設為null, 長度必須與HPC Index series一樣
      let interestHpcIndexSeriesTop2Only = this.$lodash.cloneDeep(interestHpcIndexSeries)
      interestHpcIndexSeriesTop2Only.forEach(item => {
        if (!this.interestHpcIndexTop2.includes(item[0])) item[1] = null
      })

      let result = [
        {
          yAxis: 0,
          'data': interestHpcPercentageSeries,
          'name': this.isChooseGroupByHotIndustry ? 'HPC 含量' : '受眾含量',
          'turboThreshold': 0,
          'type': 'column',
          'marker': {}
        },
        {
          yAxis: 0,
          'data': interestHpcPercentageSeriesTop3Only,
          'name': 'Top3 含量',
          'turboThreshold': 0,
          'type': 'column'
        }
      ]
      if (this.isChooseGroupByHotIndustry) {
        // HPC Index series
        result.push({
          yAxis: 1,
          'data': interestHpcIndexSeries,
          'name': 'HPC Index',
          'turboThreshold': 0,
          'type': 'line',
          'marker': {
            'symbol': 'circle',
            'enabled': false
          },
          'dashStyle': 'Solid'
        })

        // HPC Index series with top 2 values only
        result.push({
          yAxis: 1,
          data: interestHpcIndexSeriesTop2Only,
          name: 'Top Rate',
          turboThreshold: 0,
          type: 'scatter',
          marker: { symbol: 'circle', enabled: true },
          _colorIndex: 3,
          _symbolIndex: 3,
          enableMouseTracking: false,
          showInLegend: false
        })
      }

      return result
    },
    /**
     * 準備「特定議題分佈 ( 依HPC含量排序 )」圖表的資料
     */
    chartKeywordHpcPercentageSeries () {
      if (this.target.keyword_rank_by_percentage === undefined) return null

      // HPC含量的 bar chart series
      let keywordHpcPercentageSeries = this.target.keyword_rank_by_percentage.map(keyword => {
        return [keyword.name, parseFloat(keyword.percentage)]
      })

      // HPC含量的 bar chart series ( 屏除掉 top 3以外的數值 )
      // Top 3 percentage 的 array 要跟 interestHpcPercentageSeries 一樣長。只是把 top 3的圖蓋在第一個series的圖上
      let topThree = this.target.keyword_percentage_top.map((keyword) => keyword.name)
      let keywordHpcPercentageSeriesTop3Only = this.$lodash.cloneDeep(keywordHpcPercentageSeries)
      keywordHpcPercentageSeriesTop3Only.forEach(item => {
        if (!topThree.includes(item[0])) item[1] = null
      })

      // HPC Index 的 line chart series
      let keywordHpcIndexSeries = this.target.keyword_rank_by_percentage.map(keyword => {
        return [keyword.name, parseFloat(keyword.hpc_index)]
      })

      // HPC Index 的 line series ( 屏除 top 2 以外的數值 )
      // 同上，interestHpcIndexSeriesTop2Only只是把非top2的數值設為null, 長度必須與HPC Index series一樣
      // @TODO: 不知道要不要 Top 2 ，先拿掉
      // let keywordHpcIndexSeriesTop2Only = this.$lodash.cloneDeep(keywordHpcIndexSeries)
      // keywordHpcIndexSeriesTop2Only.forEach(item => {
      //   if (!this.interestHpcIndexTop2.includes(item[0])) item[1] = null
      // })

      let result = [
        {
          yAxis: 0,
          'data': keywordHpcPercentageSeries,
          'name': this.isChooseGroupByHotIndustry ? 'HPC 含量' : '受眾含量',
          'turboThreshold': 0,
          'type': 'column',
          'marker': {}
        },
        {
          yAxis: 0,
          'data': keywordHpcPercentageSeriesTop3Only,
          'name': 'Top3 含量',
          'turboThreshold': 0,
          'type': 'column'
        }
      ]
      // HPC Index series
      // 產業熱門受眾才有 HPC Index
      if (this.isChooseGroupByHotIndustry) {
        result.push({
          yAxis: 1,
          'data': keywordHpcIndexSeries,
          'name': 'HPC Index',
          'turboThreshold': 0,
          'type': 'line',
          'marker': {
            'symbol': 'circle',
            'enabled': false
          },
          'dashStyle': 'Solid'
        })
      }
      return result
    },
    chartKeywordHpcIndexSeries () {
      if (this.target.keyword_rank_by_hpc_index === undefined) return null

      // HPC含量的 bar chart series
      let keywordHpcPercentageSeries = this.target.keyword_rank_by_hpc_index.map(mediaItem => {
        return [mediaItem.name, parseFloat(mediaItem.percentage)]
      })
      // HPC Index 的 line chart series
      let keywordHpcIndexSeries = this.target.keyword_rank_by_hpc_index.map(mediaItem => {
        return [mediaItem.name, parseFloat(mediaItem.hpc_index)]
      })
      // HPC Index 的 line series ( 屏除 top 3 以外的數值 )
      let keywordHpcIndexSeriesTop3Only = this.$lodash.cloneDeep(keywordHpcIndexSeries)
      let keywordHpcIndexTopName = this.target.keyword_hpc_index_top.map(keyword => keyword.name)
      keywordHpcIndexSeriesTop3Only.forEach(item => {
        if (!keywordHpcIndexTopName.includes(item[0])) item[1] = null
      })

      let result = [
        {
          yAxis: 0,
          'data': keywordHpcPercentageSeries,
          'name': 'HPC 含量',
          'turboThreshold': 0,
          'type': 'column',
          'marker': {}
        }

      ]
      // HPC Index series
      result.push({
        yAxis: 1,
        'data': keywordHpcIndexSeries,
        'name': 'HPC Index',
        'turboThreshold': 0,
        'type': 'line',
        'marker': {
          'symbol': 'circle',
          'enabled': false
        },
        'dashStyle': 'Solid',
        _colorIndex: 2 // 指定線圖顏色, baseChart.vue 裡的 colors
      })

      // HPC Index series with top 3 values
      // 特別標註 HPC index top 3 的 3 個點
      result.push({
        yAxis: 1,
        data: keywordHpcIndexSeriesTop3Only,
        name: 'Top Rate',
        turboThreshold: 0,
        type: 'scatter',
        marker: { symbol: 'circle', enabled: true },
        _colorIndex: 3,
        _symbolIndex: 3,
        enableMouseTracking: false,
        showInLegend: false
      })
      return result
    },
    chartDeviceSeries () {
      if (this.target.device === undefined) return null
      let desktopValue = this.target.device.desktop
      let mobileValue = this.target.device.mobile
      return [{
        'data': [
          ['Desktop', desktopValue],
          ['Mobile', mobileValue]
        ],
        'name': '百分比',
        'turboThreshold': 0
      }]
    },
    chartWebsiteSeries () {
      if (this.target.media_rank === undefined) return null
      let dataArray = []
      dataArray = this.target.media_rank.map(media => [media.name, parseInt(media.percentage)])
      return [{
        'data': dataArray,
        'name': '百分比'
      }]
    },
    planData () {
      if (this.isPurposePath) {
        const result = this.rootOptionData.plan.filter((el) => {
          return el.id === this.purposeType.id
        })
        return result ? result[0] : null
      } else {
        return null
      }
    },
    reachRateForApi () {
      return this.reachRate * 0.01
    },
    // 推薦媒體
    recommendAdFormatTypes () {
      let recommendAdTypes = []

      if (this.isPurposePath) {
        if (this.planData) {
          recommendAdTypes = this.$lodash.cloneDeep(this.planData.recommend_ad_types)
        }
      } else {
        // FIXME: @Zone hard code for audience path
        recommendAdTypes = [
          {
            ad_format_type_id: 1,
            title: 'In-Read Showroom'
          },
          {
            ad_format_type_id: 8,
            title: 'Mobile In-Read Transformer'
          }
        ]
      }

      let result = recommendAdTypes.sort((item1, item2) => {
        return item1.title.toLowerCase().indexOf('desktop')
      })

      return result
    },
    recommendMediaUids () {
      // FIXME: @Zone this.target.recommend_media may have problem: one media but appear more than once
      if (!this.target.recommend_media) return []
      return this.target.recommend_media.map(media => media.uid)
    },
    // 擁有較多高潛力消費者(HPC)*含量
    demographicMostHpcPercentage () {
      if (this.target.demographic_top === undefined) return []
      return this.target.demographic_top.map(demographic => this.changeAgeFormatFull(demographic.name)).join('、')
    },
    demographicMoreRelativeOutputRate () {
      if (this.target.demographic_index === undefined) return []
      return this.target.demographic_index.map(demographicName => this.changeAgeFormatFull(demographicName)).join('、')
    },
    // 最關注的興趣
    interest_top () {
      if (this.target.interest_top === undefined) return []
      return this.target.interest_top.map((interest) => interest.name).join('、')
    },
    // 最活躍的媒體種類
    media_category () {
      if (this.target.media_category === undefined) return []
      return this.target.media_category.join('、')
    },
    // 最常看的前 5 大媒體
    media_rank () {
      if (this.target.media_rank === undefined) return []
      let medias = this.$lodash.cloneDeep(this.target.media_rank)
      return medias
        .sort((a, b) => parseFloat(a.percentage) < parseFloat(b.percentage) ? 1 : -1)
        .map(media => media.name)
        .slice(0, 5)
        .join('、')
    },
    // 裝置分布
    moreActivityDevice () {
      let device = this.target.device
      if (device === undefined) return null
      Object.values(device)
      let biggerValue = Object.values(device).sort().pop()
      let deviceType = Object.keys(device).find(key => device[key] === biggerValue)
      switch (deviceType) {
        case 'desktop':
          return '桌機'
        case 'mobile':
          return '行動'
        default:
          return null
      }
    }
  },
  methods: {
    // guide action
    ...mapActions(['getTarget', 'setLastRecommendPath']),
    ...mapActions('speedCalculation2', ['setOptions']),
    ...mapActions('root', ['setBaseInfo']),
    // 計算每個interest底下有勾選了幾個keyword後端計算用
    countInterestKeyword (keywordIds) {
      let keywordsOptions = this.options.keywords
      if (!this.$lodash.isEmpty(keywordsOptions)) {
        const keywordIdsExist = this.$lodash.cloneDeep(keywordIds).filter(keywordId => {
          return keywordsOptions.find(keyword => keyword.remote_id === keywordId)
        })
        return keywordIdsExist.reduce((obj, currentId) => {
          let foundKeyword = keywordsOptions.find(keyword => keyword.remote_id === currentId)
          const interestId = foundKeyword.interest_id
          if (!obj[interestId]) {
            obj[interestId] = 0
          }
          obj[interestId]++
          return obj
        }, {})
      } else {
        return {}
      }
    },
    // 忽略 is_prime
    ignoreIsPrimeOption () {
      const foundTargetCategory = this.rootOptionData.targetCategory.find(item => item.id === this.targetTypeId)
      return foundTargetCategory.prime_enabled === false
    },
    // 廣告格式建議
    openDemoUrl (url) {
      window.open(url, '_blank')
    },
    setProductLineVisiblity () {
      this.showSuperImpact = !!this.planningResults.SuperImpact
      this.showSuperView = !!this.planningResults.SuperView
      this.showLINE = !!this.planningResults['LINE TODAY']
    },
    // 廣告格式建議
    getClassFromRecommendAdType (recommendAdType) {
      return recommendAdType.title.toLowerCase().indexOf('mobile') > -1 ? 'mobile' : 'desktop'
    },
    // 廣告格式建議
    getDemoLinkButtonName (name, linkArr) {
      if (linkArr.length === 1) {
        return 'DEMO'
      } else {
        return `DEMO: ${name}`
      }
    },
    setupChart () {
      let siTotalUu, siReachUu, svTotalUu, svReachUu, lineTotalUu, lineReachUu, totalUuData, reachUuData
      if (this.planningResults['SuperImpact']) {
        siTotalUu = {
          y: this.planningResults['SuperImpact']['cross_device']['total_uu'] || 0,
          color: '#FFBA87',
          name: 'SuperImpact'
        }
        siReachUu = {
          y: this.planningResults['SuperImpact']['cross_device']['reach_uu'] || 0,
          color: '#E1823C',
          name: 'SuperImpact'
        }
      }
      if (this.planningResults['SuperView']) {
        svTotalUu = {
          y: this.planningResults['SuperView']['cross_device']['total_uu'] || 0,
          color: '#87BFFF',
          name: 'SuperView'
        }
        svReachUu = {
          y: this.planningResults['SuperView']['cross_device']['reach_uu'] || 0,
          color: '#6799D2',
          name: 'SuperView'
        }
      }
      if (this.planningResults['LINE TODAY']) {
        lineTotalUu = {
          y: this.planningResults['LINE TODAY']['mobile']['total_uu'] || 0,
          color: '#8DD872',
          name: 'LINE Today'
        }
        lineReachUu = {
          y: this.planningResults['LINE TODAY']['mobile']['reach_uu'] || 0,
          color: '#46AB21',
          name: 'LINE Today'
        }
      }

      switch (this.purposeType.id) {
        case 1:
          totalUuData = [siTotalUu, svTotalUu, lineTotalUu]
          reachUuData = [siReachUu, svReachUu, lineReachUu]
          break
        case 2:
          totalUuData = [siTotalUu, lineTotalUu]
          reachUuData = [siReachUu, lineReachUu]
          break
        case 3:
          totalUuData = [siTotalUu, svTotalUu]
          reachUuData = [siReachUu, svReachUu]
          break
        case 4:
          totalUuData = [siTotalUu]
          reachUuData = [siReachUu]
          break
        case 5:
          totalUuData = [siTotalUu]
          reachUuData = [siReachUu]
          break
        case 6:
          totalUuData = [siTotalUu]
          reachUuData = [siReachUu]
          break
      }

      this.chartOptions = {
        // 讓三個數列的每個數值都不同色
        'series': [
          {
            data: totalUuData,
            'tooltip': {
              pointFormatter: function () {
                return '<span style="color:' + this.color + '">\u25CF</span> ' +
                  'Total UU: <b>' + toLocaleString(this.y) + '</b><br/>'
              }
            },
            'dataLabels': {
              'enabled': true,
              // ,.0f是highchart的特別指令，是讓該數值秀出千分位
              'format': 'Total UU：{point.y:,.0f}',
              'style': {
                'fontWeight': 'normal',
                'fontSize': '12px',
                'color': '#333',
                'textOutline': '2px #ffffff60'
              },
              'x': 10,
              'inside': true,
              'align': 'left'
            }
          },
          {
            data: reachUuData,
            'tooltip': {
              pointFormatter: function () {
                return '<span style="color:' + this.color + '">\u25CF</span> ' +
                  'Reach UU: <b>' + toLocaleString(this.y) + '</b><br/>'
              }
            },
            'dataLabels': {
              'enabled': true,
              'format': 'Reach UU：{point.y:,.0f}',
              'style': {
                'fontWeight': 'normal',
                'fontSize': '12px',
                'color': '#333',
                'textOutline': '2px #ffffff80'
              },
              'x': 10,
              'inside': true,
              'align': 'left'
            }
          }
        ],
        'title': {
          'text': ' '
        },
        'subtitle': {
          'text': ' '
        },
        'exporting': {
          'enabled': false
        },
        'chart': {
          'type': 'column',
          'polar': false,
          'backgroundColor': 'transparent',
          'height': this.productLineChartHeight,
          'inverted': true
        },
        'plotOptions': {
          'series': {
            'dataLabels': {
              'enabled': true
            }
          }
        },
        'credits': {
          'enabled': false
        },
        'pane': {
          'background': []
        },
        'responsive': {
          'rules': []
        },
        'legend': {
          'layout': 'vertical',
          'align': 'right',
          'verticalAlign': 'middle',
          'itemMarginBottom': 12,
          'enabled': false
        },
        'yAxis': [
          {
            'labels': {
              'format': ' '
            },
            'title': {
              'text': ''
            },
            'type': 'linear',
            'gridLineDashStyle': 'Solid',
            'gridLineColor': 'transparent'
          }
        ],
        'xAxis': {
          'labels': {
            'format': ' ',
            'style': {
              'fontSize': '12px'
            }
          },
          'title': {
            'text': ''
          }
        },
        'lang': {
          thousandsSep: ','
        }
      }
    },
    setSpeedOptions () {
      return conditionApi.getSpeedOptions().then(res => {
        this.setOptions(res.data)
      })
    },
    // e.g. 45-54M -> 男45-54
    // 18-55+M -> 男18-55以上
    changeAgeFormatSimple (ageString) {
      ageString = ageString.replace('+', '以上')

      if (ageString.match(/M$/)) return '男' + ageString.replace(/M$/, '')
      if (ageString.match(/F$/)) return '女' + ageString.replace(/F$/, '')
      return ageString + ' 全部'
    },
    // e.g. 45-54M -> 45-54歲男性
    // 18-55+ -> 18-55歲以上 全部
    changeAgeFormatFull (ageString) {
      const isAbove = ageString.indexOf('+') > -1
      const isMale = ageString.match(/M$/)
      const isFemale = ageString.match(/F$/)

      const gender = isMale ? '男性' : isFemale ? '女性' : '全部'
      const age = ageString.replace(/M$/, ``).replace(/F$/, ``)

      if (isAbove) {
        return age.replace('+', '歲以上') + gender
      } else {
        return `${age}歲${gender}`
      }
    },
    // 得到性別年齡選項對應到 DB record id 的 array
    getSpeedDemographicIds () {
      let demographicContent = []
      // flat() 會有相容性問題，用自己寫的 function 取代
      const flatten = arr => arr.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), [])
      // this.opions 是從後端拿到的 option (speed 用), 需要把 "55+M" 這樣的 string 對應成 id
      let allSexObjects = flatten(Object.values(this.options.demographics))

      if (this.isNotChooseGroupByGenderAge) {
        if (this.target.demographic_top && this.target.demographic_index) {
          // demographicContent: 後端拿到的年齡性別 e.g.
          // "demographic_top": ["55+M", "55+F", "18-24F"],
          // "demographic_index": ["55+M", "55+F"]
          demographicContent = this.$lodash.union([...this.target.demographic_top.map((demographic) => demographic.name), ...this.target.demographic_index])
        }
      } else {
        // transform from option to calculation page format
        // in guide: 18-40M > calculation: 18-24M 25-34M 35-40M
        const genderAgeStr = this.pathSpecificState.targetOption.name
        const isMale = genderAgeStr.indexOf('M') > -1
        const isFemale = genderAgeStr.indexOf('F') > -1

        const ageArr = genderAgeStr.replace('M', '').replace('F', '').split('-')
        const hasAbove = ageArr[1].indexOf('+') > -1
        const minAge = ageArr[0] * 1
        const maxAge = hasAbove ? 56 : ageArr[1] * 1

        const ageOptionArr = []
        let tmpAge = minAge
        if (minAge === 18) {
          ageOptionArr.push('18-24')
          tmpAge = 25
        }
        while (tmpAge < maxAge) {
          ageOptionArr.push(tmpAge + '-' + (tmpAge + 9))
          tmpAge += 10
        }
        if (hasAbove) {
          ageOptionArr.push('55+')
        }
        let genderStrArr
        switch (true) {
          case isMale:
            genderStrArr = ['M']
            break
          case isFemale:
            genderStrArr = ['F']
            break
          default:
            genderStrArr = ['M', 'F']
            break
        }

        genderStrArr.forEach((genderStr) => {
          ageOptionArr.forEach((ageOption) => {
            demographicContent.push(ageOption + genderStr)
          })
        })
      }

      demographicContent = demographicContent.map(sexStringName => {
        let foundSexObject = allSexObjects.find(sexObject => sexObject.name === sexStringName)
        if (foundSexObject) return foundSexObject.id
      })
      // 去掉 undefined
      demographicContent = demographicContent.filter(existItem => existItem)
      return demographicContent
    },
    getInterestIds () {
      // stpe2某些受眾鎖定方式(性別年齡)要忽略 step1 廣告目的裡的 is_prime
      // 忽略推薦興趣並全選興趣做計算，在帶入 speed 時要全選興趣
      return this.ignoreIsPrimeOption()
        ? this.options.interests.map(item => item.id)
        : this.target.interest_top.map((interest) => interest.id)
    },
    getSpeedMediaFormat () {
      const isPrime = this.isPrimeConditionForSpeed
      let includeIds = isPrime ? this.recommendMediaUids : []
      return {
        'isPrime': isPrime,
        'includeIds': includeIds,
        'excludeIds': []
      }
    },
    // 導引流程設定的選項，準備拿來帶入計算頁面用
    guideSelectedData () {
      let interestContent = {}
      if (this.isChooseGroupByGenderAge) {
        interestContent = {
          type: 'interest',
          interestIds: this.getInterestIds(),
          keywordIds: []
        }
      } else {
        interestContent = {
          type: 'keyword',
          interestIds: [],
          keywordIds: this.topKeywordIds
        }
      }

      let budgetReachContent = {
        type: 'reach',
        minimumBudget: (this.userIsReseller ? 50000 : 100000),
        reach: {
          'value': this.reachRate // 這邊的 reachRate 沒有除以一百
        },
        budget: {
          value: 100000,
          format: {}
        }
      }
      let playDateObject = {
        dateSeries: getDatesSeries(this.schedule[0], this.schedule[1]),
        startEndDates: [this.schedule[0], this.schedule[1]]
      }
      // {"type":"reach","budget":{"value":100000,"format":{"1":0,"6":0,"7":0,"8":100}},"reach":{"value":50,"format":{"1":0,"6":1,"7":1,"8":0}}}
      return {
        playDate: playDateObject,
        media: this.getSpeedMediaFormat(),
        demographics: this.getSpeedDemographicIds(),
        interestKeyword: interestContent,
        budgetReach: budgetReachContent,
        start_date: this.schedule[0],
        end_date: this.schedule[1]
      }
    },
    budgetReachForPurpose () {
      return {
        si: {
          type: 'reach',
          minimumBudget: (this.userIsReseller ? 50000 : 100000),
          reach: { value: this.reachRate },
          budget: { value: 100000 }
        },
        sv: {
          type: 'budget',
          minimumBudget: (this.userIsReseller ? 50000 : 100000),
          budget: { value: (this.showSuperView ? this.planningResults['SuperView']['cross_device']['budget'] : 100000) },
          reach: { value: 50 }
        },
        line: {
          type: 'budget',
          minimumBudget: (this.userIsReseller ? 50000 : 100000),
          budget: { value: (this.showLINE ? this.planningResults['LINE TODAY']['mobile']['budget'] : 100000) },
          reach: { value: 50 }
        }
      }
    },
    budgetReachForAudience () {
      return {
        type: 'reach',
        minimumBudget: (this.userIsReseller ? 50000 : 100000),
        reach: { value: this.reachRate },
        budget: { value: 0 }
      }
    },
    setAdformatType () {
      const recommendAdFormatTypes = this.purposeType.recommend_ad_format_types
      let siData = null
      let lineData = null
      let svData = null
      if (this.showSuperImpact) {
        const siID = this.options.product_lines['SuperImpact'].list[0].id
        const siRecommendAdFormatID = recommendAdFormatTypes[siID]
        let siRecommendAdFormats = this.options.product_lines['SuperImpact'].list[0].ad_format_types.filter(adFormat => siRecommendAdFormatID.includes(adFormat.id))
        let siAdFormatTypeRatioObject = siRecommendAdFormatID.map(adFormatId => {
          return {
            id: adFormatId,
            // SuperImpact 帶 reach, SuperView, Line 帶 budget
            rate: (this.reachRate / 100)
          }
        })
        siData = {
          ad_format: siRecommendAdFormats,
          ad_format_types: siAdFormatTypeRatioObject,
          mode: {
            request: 1,
            quantity: this.reachRate / 100 // reach %
          }
        }
      } else {
        siData = {
          ad_format: [],
          ad_format_types: [],
          mode: {
            request: 1,
            quantity: this.reachRate / 100 // reach %
          }
        }
      }
      if (this.showLINE) {
        const lineID = this.options.product_lines['LINEToday'].list[0].id
        const lineRecommendAdFormatID = recommendAdFormatTypes[lineID]
        let lineRecommendAdFormats = this.options.product_lines['LINEToday'].list[0].ad_format_types.filter(adFormat => lineRecommendAdFormatID.includes(adFormat.id))
        let lineAdFormatTypeRatioObject = lineRecommendAdFormatID.map(adFormatId => {
          return {
            id: adFormatId,
            rate: 1 / lineRecommendAdFormatID.length
          }
        })
        lineData = {
          ad_format: lineRecommendAdFormats,
          ad_format_types: lineAdFormatTypeRatioObject,
          mode: {
            request: 0,
            quantity: this.planningResults['LINE TODAY']['mobile']['budget'] // 預算金額
          }
        }
      } else {
        lineData = {
          ad_format: [],
          ad_format_types: [],
          mode: {
            request: 0,
            quantity: 0 // 預算金額
          }
        }
      }
      if (this.showSuperView) {
        svData = {
          ad_format: [],
          ad_format_types: [],
          mode: {
            request: 0,
            quantity: this.planningResults['SuperView']['cross_device']['budget'] // 預算金額
          }
        }
      } else {
        svData = {
          ad_format: [],
          ad_format_types: [],
          mode: {
            request: 0,
            quantity: 0 // 預算金額
          }
        }
      }
      return {
        si: siData,
        sv: svData,
        line: lineData
      }
    },
    // 送後端計算的 parameters
    speedAllSelectedData () {
      // defaultSelectedData: 原本就該全選的東西: 城市、isp, 品牌... 等
      let defaultSelectedData = {
        'user_type': 'User',
        'flvSecond': 60,
        'frequency': 2,
        'hourlies': [1, 2, 3, 4],
        'platformType': 'speedDmp',
        'cities': {
          'regions': [1, 2, 3, 4],
          'municipalities': [1, 2, 4, 7, 12, 13]
        },
        'isps': [1, 2, 3, 4, 5],
        'deviceBrands': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        'placement_type_id': 2
      }

      // condition 這個 key 裡的 value 是後端存入 qp_condition 的 condition column, 會再送去做計算結果
      defaultSelectedData['condition'] = this.speedDefaultSelectedDataCondition()

      // playDate
      let playDateObject = {
        dateSeries: getDatesSeries(this.schedule[0], this.schedule[1]),
        startEndDates: [this.schedule[0], this.schedule[1]]
      }
      defaultSelectedData['playDate'] = playDateObject

      // 設定應有的 baseInfo，像是
      let clonedBaseInfo = this.$lodash.cloneDeep(this.baseInfo)
      clonedBaseInfo.campaignName = 'QuickPlan建議規劃'

      // 更新 campaignName 到 BaseInfo
      this.setBaseInfo(clonedBaseInfo)

      // 如果沒有 clientName 就給預設的 clientName，後端做計算需要
      if (!this.userClientName || !clonedBaseInfo.clientName) clonedBaseInfo.clientName = this.defaultClientName
      defaultSelectedData.baseInfo = clonedBaseInfo
      defaultSelectedData.current_user_id = this.userId
      let backendFormatInfo = baseInfoFormatConvertor(clonedBaseInfo)

      // 讓後端知道是「廣告活動目的(true)」還是「受眾輪廓洞察(false)」
      let isFromPlan = { is_plan: this.isPurposePath }

      // @FIXME 現在「要帶到計算頁面的」在這個hash的第一層。而要送到API的，在condition裡面。
      // 但是兩邊的資料有大量的重複，只是Key不一樣。是不是只在一邊做計算，另外一邊就改key名字就好。
      // 另外，是不是應該要把要帶到計算結果的也用一個key包起來，會比較乾淨
      let retval = { ...defaultSelectedData, ...backendFormatInfo, ...this.guideSelectedData(), ...isFromPlan }
      return retval
    },
    // 針對受眾來送後端計算的 parameters
    speedAllSelectedDataForAudience () {
      let speedAllSelectedData = this.speedAllSelectedData()

      // 選擇 SuperImpact
      speedAllSelectedData.condition.product_line_id = this.PRODUCT_LINE_IDS['SuperImpact']
      speedAllSelectedData.condition.pick_product_line = 1
      speedAllSelectedData.condition.ad_format = []
      speedAllSelectedData.condition.ad_format_types = []

      // NOTE: get empty value to clear the data that don't need pass to calculation page
      const superImpactEmptyValue = dataReducer.getDefaultSelectedData(this.options, { 'root/userIsReseller': this.userIsReseller })[PRODUCT_LINE.SUPER_IMPACT]
      speedAllSelectedData.budgetReach = superImpactEmptyValue.budgetReach
      speedAllSelectedData.playDate = superImpactEmptyValue.playDate

      return speedAllSelectedData
    },

    /**
     * 將導引流程的選項傳回父組件 ( for 目的 )
     */
    emitSpeedAllSelectedDataForProductLines () {
      let siSelectedData = this.$lodash.cloneDeep(this.speedAllSelectedData())
      let svSelectedData = this.$lodash.cloneDeep(this.speedAllSelectedData())
      let lineSelectedData = this.$lodash.cloneDeep(this.speedAllSelectedData())
      // SuperView 的素材秒數要改成 1~30秒
      svSelectedData.flvSecond = 30
      svSelectedData.condition.flv_second = 30

      siSelectedData.condition = {
        ...siSelectedData.condition,
        ...this.setAdformatType().si,
        pick_product_line: 1,
        product_line_id: this.PRODUCT_LINE_IDS['SuperImpact']
      }
      siSelectedData.budgetReach = this.budgetReachForPurpose().si

      svSelectedData.condition = {
        ...svSelectedData.condition,
        ...this.setAdformatType().sv,
        pick_product_line: 2,
        product_line_id: this.PRODUCT_LINE_IDS['SuperViewDrama']
      }
      svSelectedData.budgetReach = this.budgetReachForPurpose().sv

      lineSelectedData.condition = {
        ...lineSelectedData.condition,
        ...this.setAdformatType().line,
        pick_product_line: 3,
        product_line_id: this.PRODUCT_LINE_IDS['LineToday']
      }

      lineSelectedData.budgetReach = this.budgetReachForPurpose().line

      this.$emit('update:selectedDataFromGuide', {
        SuperImpact: siSelectedData,
        SuperView: svSelectedData,
        LINEToday: lineSelectedData
      })
    },

    // 用在 defaultSelectedData 裡的 condition
    // condition 是後端用來建立 qp_conditon 的 condition column
    // 非 condition 的 key 是前端用的，可以 binding 計算頁面上的選項
    speedDefaultSelectedDataCondition () {
      const datesSeries = getDatesSeries(this.schedule[0], this.schedule[1])
      const dateIntervalArr = datesSeries.map((date) => date.replace(/-/g, ''))
      let isPrime = this.isPrimeConditionForSpeed
      let includeIds = isPrime ? this.recommendMediaUids : []
      let retval = {
        'target_id': this.targetTypeId,
        'date_interval': dateIntervalArr,
        'freq': 2,
        // 如果是 SV, flv_second 會在後端改成 30
        'flv_second': 60,
        'mode': {
          // reach 是 1
          'request': 1,
          'quantity': this.reachRateForApi
        },
        'demo_ids': this.getSpeedDemographicIds(),
        'hour_ids': [1, 2, 3, 4],
        'interest_ids': this.isChooseGroupByGenderAge ? this.getInterestIds() : [],
        'keyword_ids': this.isChooseGroupByGenderAge ? [] : this.topKeywordIds,
        'target_keywords': this.isChooseGroupByGenderAge ? [] : this.countInterestKeyword(this.topKeywordIds),
        'media': {
          'is_prime': isPrime,
          'media_ids': includeIds
        },
        'cities': {
          'all_selected': true,
          'city_ids': [1, 2, 3, 4, 5, 15, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 17]
        },
        'isps': {
          'all_selected': true,
          'isp_ids': [1, 2, 3, 4, 5]
        },
        'm_brands': {
          'all_selected': true,
          'm_brand_ids': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
        }
      }
      // 只有「廣告活動目的」有plan id
      if (this.purposeType !== undefined) retval.plan_id = this.purposeType.id
      return retval
    },
    deviceTypeCount (deviceTypeArray) {
      let mobileCount = deviceTypeArray.filter(device => device === 'mobile').length
      let desktopCount = deviceTypeArray.filter(device => device === 'desktop').length
      return { mobileCount: mobileCount, desktopCount: desktopCount }
    }
  },
  mounted () {
    this.$emit('update:loading', true)
    const guideState = this.$store.state.guide[this.path]

    if (this.isPurposePath) {
      // ----------
      // 廣告活動目的
      // ----------
      Promise.all([
        this.getTarget({
          targetId: guideState.targetOption.id,
          planId: guideState.purposeType.id,
          categoryId: guideState.targetType.id
        }),
        this.setSpeedOptions()
      ])
        .then(() => {
          let selectedData = this.speedAllSelectedData()
          return conditionApi.getPlanningResult(selectedData)
        })
        .then(response => {
          if (response.data.success === true) {
            this.planningResults = response.data.data

            // 依照不同目的，在section 1顯示不同的product lines區塊
            this.setProductLineVisiblity()

            // 準備 section 3的圖表資料
            this.setupChart()

            // 把導引流程的選項跟結果傳到父組件，讓使用者決定是否要再帶到計算頁面
            let clonePlanningResults = this.$lodash.cloneDeep(this.planningResults)
            clonePlanningResults.LINEToday = clonePlanningResults['LINE TODAY'] // 後端來的名字是 LINE，但是前端都使用 LINEToday
            this.$emit('update:calculationResultFromGuide', clonePlanningResults)
            this.emitSpeedAllSelectedDataForProductLines()

            // 將導引結果的網址儲存起來，方便計算頁面提供一個連結連回到這裏
            this.setLastRecommendPath(this.path)
            this.$emit('update:loading', false)
          }
        })
        .catch(error => {
          this.$emit('update:loading', false)
          this.error = error.toString()
        })
    } else {
      // ----------
      // 受眾輪廓洞察
      // ----------
      Promise.all([
        this.getTarget({
          targetId: guideState.targetOption.id,
          categoryId: guideState.targetType.id
        }),
        this.setSpeedOptions()
      ])
        .then(() => {
          let selectedData = this.speedAllSelectedDataForAudience()
          return conditionApi.getProfilingResult(selectedData)
        })
        .then(response => {
          let selectedData = this.speedAllSelectedDataForAudience()
          this.calculationResult = this.$lodash.cloneDeep(response.data.data)

          // 把導引流程的選項跟結果傳到父組件，讓使用者決定是否要再帶到計算頁面
          this.$emit('update:calculationResultFromGuide', { [PRODUCT_LINE.SUPER_IMPACT]: this.calculationResult })
          this.$emit('update:selectedDataFromGuide', { [PRODUCT_LINE.SUPER_IMPACT]: selectedData })

          // 將導引結果的網址儲存起來，方便計算頁面提供一個連結連回到這裏
          this.setLastRecommendPath(this.path)

          this.$emit('update:loading', false)
        })
        .catch(error => {
          this.$emit('update:loading', false)
          this.error = error.toString()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .hpc_infomation {
    display: inline-flex;
    font-size: 16px;
    color: #9b9b9b;
    .fa-info-circle {
      margin-right: 5px;
    }
  }
  .max-800{
    max-width:800px;
    margin:0 auto;
  }

  .outcome_chart_wrapper{
    width:100%;
  }

  .guide_context_desktop{
    padding-left: 85px;
    margin-top:-56px;
  }
  .guide_context_desktop .guide_icon_circle{
    background:#e89022;
    border-color:#FFEEDF;
  }
  .guide_context_mobile .guide_icon_circle{
    border-color:#DFEFFF;
    background:rgb(64, 158, 255);
  }
  .UU_number{
    float:right;
    font-size:14px;
    text-align: right;
    margin-left:-100px;
  }
  .UU_indicator{
    font-size:48px;
    display: inline-flex;
    flex-direction: column;
    text-align: center;
  }
  .UU_indicator span{
    font-size:16px;
    margin-top:-64px;
    color:#fff;
    font-weight: bold;
  }
  .guide_icon_circle{
    color:  rgb(64, 158, 255);
    background-color:rgb(255, 255, 255);
    border:10px solid rgb(64, 158, 255);
    border-radius: 50%;
    box-sizing: content-box;
    padding: 12px;
    margin-bottom: 8px;
    height: 40px;
    width: 40px;
  }
  .UU_indicator .guide_icon_circle{
    height: 72px;
    width: 72px;
    padding: 32px 40px 48px;
    color:#fff;
  }
  .guide_title{
    text-align:left;
    font-size:18px;
  }
  .guide_tips{
    padding:8px 0 8px 0;
    background:rgb(64, 158, 255);
    margin-top:24px;
    color:#fff;
  }
  .guide_tips:before{
    border-top:2px solid #fff;
    width:100%;
    height:24px;
    display: table;
    content: "";
  }
  .guide_tips:after{
    border-bottom:2px solid #fff;
    width:100%;
    height:24px;
    display: table;
    content: "";
  }
  .guide_tips_inner{
    margin: 0 auto 0 auto;
    display: flex;
    justify-content: center;
  }
  .guide_tips_title {
    text-align:center;
    font-size:16px;
    font-weight: bold;
  }
  .guide_tips_context{
    padding:16px;
    line-height:1.5;
  }
  /*@FIXME: 備忘：因為這個節點是動態由 JS 產生, 改成用 inline 處理 */
  /*.tips_highlight{*/
  /*    text-decoration: underline;*/
  /*    font-weight: bold;*/
  /*}*/
  .tips_note{
    font-size:14px;
    margin-top:8px;
    display: inline-block;
  }

  .loader {
    position: absolute;
    /* top: calc(50% - 64px); */
    left: calc(50% - 64px);
    width: 128px;
    height: 128px;
    border-radius: 50%;
    perspective: 800px;
  }

  .inner {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .inner.one {
      left: 0%;
      top: 0%;
      animation: rotate-one 2s linear infinite;
      border-bottom: 6px solid #4DA1FF;
      border-top: 6px solid #4DA1FF;
  }

  .inner.two {
    right: 0%;
    top: 0%;
    animation: rotate-two 2s linear infinite;
    border-right: 6px solid #F5A623;
    border-left: 6px solid #F5A623;
  }

  .inner.three {
    right: 0%;
    bottom: 0%;
    animation: rotate-three 2s linear infinite;
    border-top: 6px solid #00A991;
    border-bottom: 6px solid #00A991;
  }

  @keyframes rotate-one {
    0% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-two {
    0% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
    }
  }

  @keyframes rotate-three {
    0% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
    }
    100% {
      transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
    }
  }

  .hide{
    display:none;
  }
  .show{
    display:block;
  }

  .guide_title .el-col{
    margin-bottom: 8px;
    line-height: 1.5;
  }

  .guide_meta {
    font-size:24px;
    font-weight: bold;
    margin-bottom:8px;
    text-align: left;
    line-height: 1.5;
    border-bottom: 2px solid #e89022;
  }
  .bold-text {
    font-weight: bold;
    color: #111;
  }
  .guide_context{
    font-size: 16px;
    line-height: 1.5;
    text-align: left;
    padding: 16px;
  }
  .guide_context button{
    margin-top:4px;
  }
  .guide_result{
    color:#e89022;
    font-weight: bold;
  }
  .mobile .guide_result{
    color:#4da1ff;
  }
  .desktop.guide_context .el-button{
    background-color:#E89022;
    border-color:#E89022;
  }
  .guide_result_TA .guide_result {
    color: #4da1ff;
  }
  .guide_result_format{
    text-align:center;
  }
  .guide_result_format img{
    max-height:120px;
    margin:0px 0;
    width:auto;
    max-width:100%;
    padding-right:16px;
  }
  .audiance_box{
    display:flex;
    margin-bottom:8px;
    align-items: top;
  }
  .audiance_box:nth-child(n){
    flex-direction: row-reverse;
  }
  .audiance_pic{
    width:100%;
    box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
    background-color: #ffffff;
    margin-bottom:16px;
  }
  .audiance_text{
    width:100%;
    line-height: 1.5;
  }
  .audiance_text_title{
    font-weight:bold;
    font-size: 18px;
    margin-bottom: 8px;
  }
  .audiance_box_gutter{
    width:64px;
  }

  /*demo 用*/
  .guide_context_desktop .guide_icon_circle{
    border-color: #ffbe84;
  }
  .guide_context_mobile .guide_icon_circle{
    border-color: #8fc4ff
  }
  .audiance_pic{
    box-shadow: 0 4px 10px 0 rgba(45, 45, 45, 0.5);
  }

  // 受眾量體與建議預算
  .product-line {
    font-size: 14px;
    padding: 16px 16px;
    margin-bottom: 10px;
    .product-line-name {
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 5px;
    }
    .product-line-result {
      padding: 0 8px;
      color: #4a4a4a;
      line-height: 1.4em;
    }
    &#superimpact-info {
      background-color: #ffe7d4;
      .product-line-name {
        color: #e86522;
      }
    }
    &#superview-info {
      background-color: #d9ebff;
      .product-line-name {
        color: #3583be;
      }
    }
    &#linetoday-info {
      background-color: #ddffd9;
      .product-line-name {
        color: #57c62d;
      }
    }
  }

  #step5-profile-analysis {
    .guide_meta {
      margin-top: 40px;
      margin-bottom: 20px;
      font-weight: bold;
    }
    #analysis-description {
      font-size:20px;
      margin-bottom: 16px;
      .guide_result {
        color: #e89022;
      }
    }
  }

</style>
